var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1.80001C6.81442 1.80001 1.80001 6.81442 1.80001 13C1.80001 16.9076 3.80096 20.3489 6.83702 22.3535L7.76942 18.6239C8.12555 17.1994 9.4055 16.2 10.8739 16.2H15.1261C16.5945 16.2 17.8745 17.1994 18.2306 18.6239L19.163 22.3535C22.1991 20.3489 24.2 16.9076 24.2 13C24.2 6.81442 19.1856 1.80001 13 1.80001ZM17.7159 23.162L16.6784 19.012C16.5003 18.2997 15.8603 17.8 15.1261 17.8H10.8739C10.1397 17.8 9.49971 18.2997 9.32165 19.012L8.28415 23.162C9.71669 23.828 11.314 24.2 13 24.2C14.686 24.2 16.2833 23.828 17.7159 23.162ZM0.200012 13C0.200012 5.93077 5.93077 0.200012 13 0.200012C20.0693 0.200012 25.8 5.93077 25.8 13C25.8 17.8925 23.0549 22.1425 19.0247 24.2962C17.2284 25.2561 15.1765 25.8 13 25.8C10.8235 25.8 8.77166 25.2561 6.97531 24.2962C2.94511 22.1425 0.200012 17.8925 0.200012 13ZM9.80001 8.20001C9.80001 7.31636 10.5164 6.60001 11.4 6.60001H14.6C15.4837 6.60001 16.2 7.31636 16.2 8.20001V12.2C16.2 13.0837 15.4837 13.8 14.6 13.8H11.4C10.5164 13.8 9.80001 13.0837 9.80001 12.2V8.20001ZM11.4 8.20001V12.2H14.6V8.20001H11.4Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.975a9ba86daf325457b936f6cfaedb5f.svg";
export { ForwardRef as ReactComponent };